<template>
    <figure class="image circular" @click="$emit('click')">
        <div v-if="!profile.photo" class="default">{{initials}}</div>
        <img v-else :src="profile.photo" alt="Avatar"/>
    </figure>
</template>

<script>
export default {
    name: 'Avatar',
    props: ['user'],
    computed: {
        profile() {
            return this.user || this.$store.state.user.user;
        },
        initials() {
            let initials = this.profile.first_name ? this.profile.first_name.charAt(0) : '';
            initials += this.profile.last_name ? this.profile.last_name.charAt(0) : '';
            return initials;
        },
    },
};
</script>

<style scoped>
    .default {
        color: white;
        font-weight: bold;
        text-align: center;
    }

    .is-16x16 .default {
        margin-top: 0.05rem;
        font-size: 0.6rem;
    }

    .is-24x24 .default {
        margin-top: 0.3rem;
        font-size: 0.8rem;
    }

    .is-32x32 .default {
        margin-top: 0.35rem;
        font-size: 1.1rem;
    }

    .is-128x128 .default {
        margin-top: 0.4rem;
        font-size: 5.5rem;
    }

    .circular {
        border-radius: 50%;
        position: relative;
        overflow: hidden;
        background: #4857e6;
    }

    .circular img {
        min-width: 100%;
        min-height: 100%;
        width: auto;
        height: auto;
        position: absolute;
        left: 50%;
        top: 50%;
        -webkit-transform: translate(-50%, -50%);
        -moz-transform: translate(-50%, -50%);
        -ms-transform: translate(-50%, -50%);
        transform: translate(-50%, -50%);
    }
</style>
